var exports = {
  "z": "x620889e6--59be21--root",
  "A": "x620889e6--59be21--item",
};

module.exports = exports;
